import React from "react";
import { DashboardIcon, FileTextIcon, HelpIcon, HomeLineIcon, IdCardIcon, ImageIcon, MegaphoneIcon, MonitorIcon, StarLineIcon, UserSearchIcon, UsersLineIcon, WatchLineIcon } from "../../../img/svg/adminIcons";

export interface IAdminNavItem {
    to: string;
    // segmento da URL após /admin/ ("" = Início), usado para marcar o item ativo
    segment: string;
    label: string;
    description: string;
    icon: React.ReactNode;
}

export interface IAdminNavSection {
    title?: string;
    items: IAdminNavItem[];
}

// fonte única do menu do painel (sidebar e atalhos da tela Início), filtrada por role
export function getAdminNav(roles: string[] | undefined): IAdminNavSection[] {

    const isAdmin = !!roles?.includes("admin");
    const isAdvertiser = !!roles?.includes("advertiser");

    const sections: IAdminNavSection[] = [];

    const general: IAdminNavItem[] = [
        { to: "/admin", segment: "", label: "Início", description: "Visão geral e atalhos do painel.", icon: <HomeLineIcon /> },
    ];
    if (isAdmin || isAdvertiser) {
        general.push({ to: "/admin/buyer-lookup", segment: "buyer-lookup", label: "Consultar Comprador", description: "Veja o score de um comprador pelo e-mail antes de fechar negócio.", icon: <UserSearchIcon /> });
    }
    sections.push({ items: general });

    if (isAdmin) {
        sections.push({
            title: "Administração",
            items: [
                { to: "/admin/general", segment: "general", label: "Geral", description: "Métricas de relógios, usuários e solicitações pendentes.", icon: <DashboardIcon /> },
                { to: "/admin/home", segment: "home", label: "Home", description: "Imagem do header e vídeo da página inicial.", icon: <MonitorIcon /> },
                { to: "/admin/faqs", segment: "faqs", label: "FAQs", description: "Perguntas frequentes exibidas no site.", icon: <HelpIcon /> },
                { to: "/admin/ads", segment: "ads", label: "Anúncios", description: "Publicidade de terceiros exibida na home.", icon: <MegaphoneIcon /> },
                { to: "/admin/users", segment: "users", label: "Usuários", description: "Busca, verificações manuais e papéis de acesso.", icon: <UsersLineIcon /> },
                { to: "/admin/banners", segment: "banners", label: "Banners", description: "Relógios em destaque no carrossel da home.", icon: <ImageIcon /> },
                { to: "/admin/watches", segment: "watches", label: "Relógios", description: "Todos os relógios cadastrados: busca e status.", icon: <WatchLineIcon /> },
                { to: "/admin/reviews", segment: "reviews", label: "Avaliações", description: "Moderação de avaliações e pedidos de exclusão.", icon: <StarLineIcon /> },
                { to: "/admin/logs", segment: "logs", label: "Logs", description: "Trilha de auditoria das ações administrativas.", icon: <FileTextIcon /> },
            ]
        });
    }

    if (isAdvertiser) {
        sections.push({
            title: "Anunciante",
            items: [
                { to: "/admin/my-contact", segment: "my-contact", label: "Meu Contato", description: "Descrição e redes exibidas na sua página de anunciante.", icon: <IdCardIcon /> },
                { to: "/admin/my-watches", segment: "my-watches", label: "Meus Relógios", description: "Rascunhos, anúncios em exibição e vendas.", icon: <WatchLineIcon /> },
                { to: "/admin/my-reviews", segment: "my-reviews", label: "Minhas avaliações", description: "Avaliações recebidas e pedidos de exclusão.", icon: <StarLineIcon /> },
            ]
        });
    }

    return sections;
}
